export default 'Outils CEE & énergie | Solution Éco France';
